<!-- components/Survey/questions/InfoSlide.svelte -->
<script>
  import { fade } from 'svelte/transition';
  import logoImage from "../../../assets/images/logos/cha_logo_2.png";

  
  export let title = '';
  export let description = '';
  export let icon = null; // Keeping for compatibility
  export let video_link = null; // Optional video embed URL
  
  // Split the title if it contains a colon
  let mainTitle = title;
  let benefitText = description;
  
  if (title.includes(':')) {
    const parts = title.split(':');
    mainTitle = parts[0];
    // If there's description content, use that, otherwise use what comes after the colon
    if (!description) {
      benefitText = parts[1].trim();
    }
  }
</script>

<div class="info-slide" in:fade={{duration: 300}}>
  <div class="content-wrapper">
    <div class="logo-container">
      <img src={logoImage} alt="Mon" class="logo" />
    </div>
    
    <div class="content">
      <h2 class="benefit-title">{mainTitle}</h2>
      <p class="benefit-description">{benefitText}</p>
      {#if video_link}
        <div class="video-container">
          <iframe
            src={video_link}
            title="Info video"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      {/if}
      <div class="separator"></div>
    </div>
  </div>
</div>

<style>
  .info-slide {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .content-wrapper {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    padding: 2rem 1.5rem;
    background-color: white;
    border-radius: 8px;
  }
  
  .logo-container {
    margin-bottom: 2.5rem;
  }
  
  .logo {
    height: 110px;
    width: auto;
  }
  
  .content {
    margin-bottom: 1rem;
  }
  
  .benefit-title {
    font-size: 1.4rem;
    color: #333;
    margin-bottom: 1rem;
    font-weight: 700;
    line-height: 1.3;
  }
  
  .benefit-description {
    font-size: 1.4rem;
    color: #333;
    line-height: 1.5;
    margin-bottom: 2rem;
    font-weight: 400;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
  }

  .video-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    margin-bottom: 2rem;
  }

  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;           /* rounded corners */
    border: 10px solid #BC955C;    /* gold-ish border */
    box-shadow: 0 4px 12px rgba(0,0,0,0.2); /* optional shadow for depth */
  }
  
  .separator {
    width: 80px;
    height: 4px;
    background-color: #BC955C; /* MONSTERS eye gold color */
    margin: 0 auto;
  }
  
  @media (max-width: 768px) {
    .content-wrapper {
      padding: 1.5rem 1rem;
    }
    
    .logo {
      height: 40px;
    }
    
    .benefit-title {
      font-size: 1.3rem;
    }
    
    .benefit-description {
      font-size: 1.2rem;
    }
  }
</style>